@use '@/styles/tokens' as *;

// Figma node 232:359827 — three chip groups, 20px apart; 40px chips with a 12px corner.

.panel {
  display: flex;
  flex-direction: column;
  gap: var(--space-5);
}

.group {
  margin: 0;
  padding: 0;
  border: none;
}

.groupLabel {
  padding: 0;
  font-size: $font-size-sm;
  line-height: 1.3;
  color: $color-accent1-900;
}

.chips {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: var(--space-2);
}

.chip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 40px;
  padding: 10px 19px;
  border: 1px solid var(--border-subtle);
  border-radius: $radius-xl;
  background: var(--surface-card);
  font-size: $font-size-15;
  line-height: 1.3;
  color: var(--text-primary);
  white-space: nowrap;
  cursor: pointer;
  transition:
    background 150ms ease,
    color 150ms ease;

  &:hover {
    background: $color-light-brown-100;
  }

  &:focus-visible {
    outline: none;
    box-shadow: var(--focus-ring);
  }
}

.chipActive {
  background: $color-brand-700;
  color: var(--text-inverse);

  &:hover {
    background: $color-brand-800;
  }
}
